/*!
 *
 * Angle - Bootstrap Admin App + ReactJS
 *
 * Version: @version@
 * Author: @author@
 * Website: @url@
 * License: @license@
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));
